import React, { useContext, useState } from 'react';
import { Input, Typography } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import AlertCard from './AlertCard';
import { ALERT_CATEGORY, triggerDataAlert } from '../../mqtt/aws';
import { SimulatorContext } from 'store/context';

const { Text } = Typography;

const TyrePressureAlert = ({ messageApi, onTriggered }) => {
  const { stsToken: credentials, vehicleSimulatorSettings: { serialNo, vehicleKey } } = useContext(SimulatorContext);
  const [pressure, setPressure] = useState('');
  const [loading, setLoading] = useState(false);

  const triggerPressureAlert = async () => {
    setLoading(true);
    await triggerDataAlert({ serialNo, vehicleKey, actual: pressure }, credentials, ALERT_CATEGORY.LOW_TYRE_PRESSURE_ALERT)
      .then(() => { messageApi.success('Tyre pressure alert triggered successfully'); onTriggered?.({ success: true, value: pressure ? `${pressure} PSI` : null }); })
      .catch(() => { messageApi.error('Failed to trigger tyre pressure alert'); onTriggered?.({ success: false, value: pressure ? `${pressure} PSI` : null }); })
      .finally(() => setLoading(false));
  };

  return (
    <AlertCard
      index={1}
      title="Low Tyre Pressure"
      icon={<CaretDownOutlined />}
      iconBg="#eff6ff"
      iconColor="#2563eb"
      threshold="30 PSI"
      onTrigger={triggerPressureAlert}
      triggerLabel="Trigger Pressure Alert"
      loading={loading}
    >
      <Text style={{ fontSize: 11, color: '#64748b' }}>Enter current tyre pressure value</Text>
      <Input
        placeholder="Tyre pressure in PSI"
        type="number"
        value={pressure}
        onChange={(e) => setPressure(e.target.value)}
        suffix={<Text style={{ color: '#94a3b8', fontSize: 11 }}>PSI</Text>}
      />
    </AlertCard>
  );
};

export default TyrePressureAlert;
